let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jy9VC")).then(() => parcelRequire('1M1oj'));